import {
  Box,
  Button,
  Flex,
  Heading,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
} from "../../../../components/Models/admin-modal-theme";
import { closeShowStudentDataModel } from "../../../../modules/admin-modules/models/Actions";

const ShowPassword = ({ data }) => {
  const openStudentData = useSelector((state) => state.model.isOpen9);
  const dispatch = useDispatch();

  const header = (
    <Box>
      <Heading
        fontSize="28px"
        fontWeight="800"
        color="var(--text-primary)"
        fontFamily="'Amiri','Tajawal',sans-serif"
        textAlign="center"
      >
        Student Data
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="var(--text-muted)"
        textTransform="uppercase"
        letterSpacing="0.12em"
        fontWeight="700"
        textAlign="center"
      >
        Credentials for the new student
      </Text>
    </Box>
  );

  const closeFunc = () => {
    dispatch(closeShowStudentDataModel());
  };

  const fieldBlock = (label, value, { mono = false } = {}) => (
    <Box>
      <Text
        as="span"
        display="block"
        fontSize="14px"
        fontWeight="700"
        color="var(--text-primary)"
        mb={2}
        textAlign="left"
      >
        {label}
      </Text>
      <Box
        px={4}
        py={3}
        bg="var(--surface-muted)"
        border="1px solid"
        borderColor="var(--border-subtle)"
        borderRadius="lg"
        fontSize="md"
        fontWeight="600"
        color="var(--text-primary)"
        fontFamily={mono ? "ui-monospace, monospace" : undefined}
        wordBreak="break-word"
      >
        {value != null && String(value).trim() !== "" ? value : "—"}
      </Box>
    </Box>
  );

  return (
    <MainModel
      header={header}
      closeFunc={closeFunc}
      openVar={openStudentData}
      buttonTitle={null}
      size="md"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={{ ...adminModalBodyProps, pb: 6 }}
      hideDefaultFooter
    >
      <Stack spacing={8} dir="ltr" w="100%">
        <VStack align="stretch" spacing={5}>
          {fieldBlock("Student Name", data?.name)}
          {fieldBlock("Password", data?.password, { mono: true })}
        </VStack>
        <Flex justify="flex-end" pt={2}>
          <Button
            onClick={closeFunc}
            variant="ghost"
            color="var(--text-primary)"
            fontWeight="800"
            _hover={{ textDecoration: "underline", bg: "rgba(91, 13, 22, 0.08)" }}
          >
            Cancel
          </Button>
        </Flex>
      </Stack>
    </MainModel>
  );
};

export default ShowPassword;
